import { render } from "./IssueArticleHeader.vue?vue&type=template&id=09d9c21e&scoped=true"
import script from "./IssueArticleHeader.vue?vue&type=script&lang=js"
export * from "./IssueArticleHeader.vue?vue&type=script&lang=js"

import "./IssueArticleHeader.vue?vue&type=style&index=0&id=09d9c21e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1533455392/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09d9c21e"]])

export default __exports__